import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GLMMaterialDesignModule} from '../material-design/material-design.module';

import {ConfirmationDialogComponent} from './confirmation-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    GLMMaterialDesignModule
  ],
  exports: [ConfirmationDialogComponent],
  declarations: [ConfirmationDialogComponent],
  providers: [],
})
export class ConfirmationDialogModule {
}

